import { FormShowTemplate, FormFieldsData } from 'framework/form';
import DemoRowItem from './DemoRowItem';
import React from 'react';
import useProjectCycleService from '../../useProjectCycleService';

const DemoWrapper = ({ cycle, data }: any) => {
  const { getDemoValidationSchema, updateDemo } = useProjectCycleService();

  return (
    <FormShowTemplate
      getDataFunc={() =>
        Promise.resolve({
          ...cycle.demo,
          status: cycle.status,
          demoDay: data?.settings?.cycleActivitySettings?.demoDay,
        })
      }
      submitFormFunc={(values: FormFieldsData) => {
        return updateDemo(cycle.demo.cycleActivityId, {
          id: values.id,
          projectId: data?.id,
          cycleActivityId: values?.cycleActivityId,
          demoDate: values?.demoDate,
          details: values?.details,
          demoRecordLink: values?.demoRecordLink,
          isSkipped: values?.isSkipped,
          skipReason: values?.isSkipped ? values.skipReason : null,
        });
      }}
      getValidationSchemaFunc={getDemoValidationSchema}
      afterSubmit={{
        message: 'You are awesome! The Demo has been successfully updated.',
      }}
    >
      <DemoRowItem />
    </FormShowTemplate>
  );
};

export default DemoWrapper;
